import type { ReactNode } from 'react'
import { selectIsAuthenticated } from '~/app/authSlice'
import { useAppSelector } from '~/app/hooks'
import { LoginPage } from './LoginPage'

/**
 * The console is either signed in or it is the login screen. No redirect, because there
 * is nowhere to redirect *from*: a 401 anywhere clears the key (see `baseQuery`) and this
 * swaps the whole tree, which keeps the URL the operator was on for when they come back.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const authenticated = useAppSelector(selectIsAuthenticated)
  return authenticated ? <>{children}</> : <LoginPage />
}
